import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import isEqual from 'lodash/isEqual'
import flatten from 'lodash/flatten'
import Tag from 'discada/dist/Tag'
import Icon from 'discada/dist/Icon'

import { toggleRebateCategory } from 'actions/quoteActions'
import { getQuoteValue, getRebateCount } from 'selectors/quoteSelectors'

import rebateCategories from 'components/Quote/rebateCategories'

import './SimpleRebates.scss'

export function SimpleRebates(props) {
  let {
      className,
      toggleRebateCategory,
      vehicleId,
      quoteId,
      selectedCategories,
      getCount,
    } = props,
    isChecked = (cat, parent = null) =>
      selectedCategories.some(rc => {
        let testCat = { ...cat }

        if (parent) testCat.parent = parent

        return (
          isEqual(rc.ID, testCat.ID) &&
          isEqual(rc.Name, testCat.Name) &&
          isEqual(rc.Subcategory, testCat.Subcategory)
        )
      })

  const makeButtons = (categories, parent) => {
    return flatten(
      categories.map(rc => {
        let count = getCount({ ...rc, parent }),
          checked = isChecked(rc, parent)

        return rc.Subcategory ? (
          makeButtons(rc.Subcategory, rc)
        ) : count ? (
          <Tag
            key={rc.Name}
            size="medium"
            color={checked ? 'success' : null}
            onClick={() => toggleRebateCategory(vehicleId, quoteId, rc, parent)}
          >
            <Icon icon={checked ? 'check' : 'plus'} /> {rc.Name}
          </Tag>
        ) : null
      }),
    ).filter(x => x)
  }

  let buttons = makeButtons(rebateCategories)

  return buttons.length ? (
    <div className={c('simple-rebates', className)}>
      <h4>What Rebates Might Apply To You?</h4>
      <div className="switch-wrapper">{buttons}</div>
    </div>
  ) : null
}

function mapStateToProps(state, op) {
  return {
    ...op,
    getCount: cat => getRebateCount(state, op.vehicleId, op.quoteId, cat),
    selectedCategories: getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      'selectedRebateCategories',
      [],
    ),
  }
}

export default connect(
  mapStateToProps,
  { toggleRebateCategory },
)(SimpleRebates)
